<template>
  <div>
    <div style="margin-bottom: 16px;">
      <el-table
              ref="multipleTableRef"
              :data="userForm"
              style="width: 100%"
              border
              @cell-click="toggleSelection"
      >
        <el-table-column label="新认证的用户信息">
          <template #default="scope">
            <UserInfoList :row="scope.row" showList="name,phone" :isDialog="true"/>
            <p>实名： {{ scope.row.identityName }}</p>
            <get-plain title="身份证号：" :code="scope.row.identityCode" :uid="scope.row.uid" :type="10" :subType="1"/>
          </template>
        </el-table-column>
        <el-table-column property="" label="用户日志" class-name="cursor">
          <template #default="scope">
            <UserLog :user-log-list="scope.row.userLogList" />
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div>
      <el-table
          ref="multipleTableRef"
          :data="pageDataList"
          style="width: 100%"
          border
          v-loading="listLoading"
          @cell-click="toggleSelection"
      >
        <el-table-column property="" label="身份证号码相同的用户信息">
          <template #default="scope">
            <UserInfoList :row="scope.row" showList="name,phone" :isDialog="true"/>
            <p>实名： {{ scope.row.identityName }}</p>
            <get-plain title="身份证号：" :code="scope.row.identityCode" :uid="scope.row.uid" :type="10" :subType="1"/>
            <p>进入情况：{{scope.row.enterType==0?'免费进入':scope.row.enterType==1?'邀请码进入':scope.row.enterType==2?'认证费用':scope.row.enterType==3?'保证金进入+认证费用':scope.row.enterType==4?'保证金+邀请码':scope.row.enterType==5?'直接进入':scope.row.enterType==6?'芝麻认证进入':scope.row.enterType==7?'身份证直接进入':scope.row.enterType==null?'未进入':''}}</p>
            <p>重复类型：{{scope.row.repeatType==1?'身份证认证':scope.row.repeatType==2?'芝麻认证':scope.row.repeatType==3?'百度认证':''}}</p>
          </template>
        </el-table-column>
        <el-table-column property="" label="用户日志" class-name="cursor">
          <template #default="scope">
            <UserLog :user-log-list="scope.row.userLogList" />
          </template>
        </el-table-column>
      </el-table>
<!--      <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">-->
<!--      </el-pagination>-->
    </div>
  </div>
</template>

<script>
import { getRepeatIdentityList } from '@/api/url'
import { getFormData } from '@/api/api'
import Dialog from "@/assets/js/dialog";
import ImgViewer from '@/assets/js/imageViewer'
import UserInfoList from "../../../../components/resume/UserInfoList";
import GetPlain from "../../../../components/resume/GetPlainDialog";
import UserLog from "../../../../components/UserLog/UserLog";
import UserLogDialog from "../../../../components/UserLog/UserLogDialog";


export default {
  name: "RepeatDialog",
  components: { UserInfoList, GetPlain, UserLog },
  props: {
    value: Object
  },
  data() {
    return {
      identityForm: this.value.identityForm,

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

    }
  },
  computed: {
    userForm() {
      let arr = []
      arr.push(this.identityForm)
      return arr
    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },


    getPage() {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      // param['pageNum'] = page;
      param['id'] = this.identityForm.userId;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getRepeatIdentityList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result;
          // this.totalRow = result['total'];
          // this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {
      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }
    }


  },
  mounted() {
    this.getPage();
  }
}
</script>

<style scoped>

</style>
